import * as React from "react";
import { Modal as AntDModal } from "antd";
import ConfirmationModal from "./ConfirmationModal";
import UpdateInfoModal from "./UpdatesInfoModal";

class Modal extends React.Component<any, any> {
  render() {
    return <AntDModal {...this.props}></AntDModal>;
  }
}

export { Modal, ConfirmationModal, UpdateInfoModal };



// WEBPACK FOOTER //
// ./client/modules/core/Modal/index.tsx